import { render, staticRenderFns } from "./seperatorFullWidth.vue?vue&type=template&id=179c96d0&scoped=true&"
import script from "./seperatorFullWidth.vue?vue&type=script&lang=js&"
export * from "./seperatorFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./seperatorFullWidth.vue?vue&type=style&index=0&id=179c96d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179c96d0",
  null
  
)

export default component.exports